import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const benefits = ['Identificar el momento exacto en que tu amígdala "toma el volante" antes de que sea tarde.', 'Aplicar el Micro-Hábito de 5 Minutos que evita que el estrés se acumule durante el día.', 'Ejecutar la Respiración 4-4-8 para bajar el ritmo cardíaco en segundos usando el mismo método que usan los equipos de operaciones especiales.', 'Usar el Protocolo de Reinicio R3P cuando la crisis ya comenzó y necesitas una salida en 60 segundos.', 'Seguir el Plan de 24 Horas que convierte estas herramientas en un sistema automático.'];
export function ProductIntroduction() {
  return <section className="w-full bg-[#FDF8F4]/80 py-16 md:py-24" data-id="element-155">
      <motion.div className="max-w-4xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-156">
        <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-6 text-center" data-id="element-157">
          Calmante Natural Ansiedad 24h
        </h2>

        <p className="font-inter text-xl text-charcoal/90 mb-12 text-center max-w-2xl mx-auto" data-id="element-158">
          El manual de instrucciones para tu sistema nervioso que nadie te dio
          en la escuela.
        </p>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg" data-id="element-159">
          <p className="font-inter text-lg text-charcoal/90 mb-8" data-id="element-160">
            En 52 páginas directas, sin relleno y con un lenguaje que cualquiera
            puede entender, aprenderás a:
          </p>

          <div className="space-y-6" data-id="element-161">
            {benefits.map((benefit, index) => <motion.div key={index} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-162">
                <CheckCircleIcon className="w-6 h-6 text-sage flex-shrink-0 mt-1" data-id="element-163" />
                <p className="font-inter text-lg text-[#1B1515]" data-id="element-164">{benefit}</p>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}